import '../../sass/pages/_homeSisomos.scss';
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/pagination';
import * as AOS from "aos";
import SplitTextV2 from '../components/SplitTextV2';
import YouTubePlayer from "youtube-player";

declare global {
    interface Window {
      dataLayer: any,
      //@ts-ignore
      player: YouTubePlayer;
    }
}

window.addEventListener('load', () => {
	initialize()
})

function initialize() {
    swiper()
	setActiveBeers()
	posterVideo()
	downloadStickers()
	animations()
    datalayers()

	AOS.init({
		once: true,
	});
}

const datalayers = () => {
    const buttonsSwiper = document.querySelectorAll('.as__home__banner-info .as__btn')
    const buttonVideo = document.querySelector('.poster__info .as__btn') as HTMLElement
    const buttonsShop = document.querySelectorAll('.as__home__shop-info .as__btn')
    const buttonShop = document.querySelector('.shop .as__btn') as HTMLElement
    const buttonSingle = document.querySelector('.as__home__singleImage__actions a') as HTMLElement
    const buttonRedes = document.querySelector('.as__home__weAre__left__action a') as HTMLElement
    const buttonRedes2 = document.querySelector('.as__home__weAre__right__actions a') as HTMLElement

    buttonsSwiper.forEach((btn: any) => {
        btn.addEventListener('click', () => {
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'Button',
                'event_label': `${btn.innerText}_Principal-Banner`,
                'interaction':'true',
                'component_name': 'Principal_Banner',
                'element_text': `${btn.innerText}`,
            });
        })
    });

    buttonVideo?.addEventListener('click', () => {
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': 'See More SiSomosAguila',
            'interaction':'true',
            'component_name': 'Home_Section_SiSomosAguila',
            'element_text': `${buttonVideo.innerText}`,
        });
    })
    
    buttonsShop.forEach((btn: any) => {
        let parent = btn.parentNode as HTMLElement
        let nombreProd = parent.querySelector('.as__title_h5') as any
        
        btn.addEventListener('click', () => {
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'Button',
                'event_label': `${nombreProd.innerText}_product-tada`,
                'interaction':'true',
                'component_name': 'Home_Section_TaDa',
                'element_text': `${nombreProd.innerText}`,
                'product': `${nombreProd.innerText}`,
                'sku': `${nombreProd.innerText}`,
            });
        })
    });

    buttonShop?.addEventListener('click', () => {
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': `${buttonShop.getAttribute('href')}_section-tada`,
            'interaction':'true',
           'component_name': 'Home_Section_TaDa',
            'element_text': 'TaDa',
            'product': 'Aguila TaDa',
            'sku': 'Aguila TaDa',
        });
    })

    buttonSingle?.addEventListener('click', () => {
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': `${buttonSingle.getAttribute('href')}_Home`,
            'interaction':'true',
           'component_name': 'Home_Section_Aguila_Plan',
            'element_text': `${buttonSingle.innerText}`,
        });
    })

    buttonRedes?.addEventListener('click', () => {
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': `${buttonRedes.getAttribute('href')}_Home`,
            'interaction':'true',
            'component_name': 'Home_Section_SiSomos',
            'element_text': `${buttonRedes.innerText}`,
        })
    })

    buttonRedes2?.addEventListener('click', () => {
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': `${buttonRedes2.getAttribute('href')}_Home`,
            'interaction':'true',
            'component_name': 'Home_Section_SiSomos',
            'element_text': `${buttonRedes2.innerText}`,
        })
    })
}

const animations = () => {
    gsap.timeline()
        .from('.as__home__banner-info .as__title, .as__home__banner-info .as__btn', {y: 50, duration: 1.5, stagger: 0.3, opacity: 0, ease: Circ.easeOut}, '<90%')

    gsap.from('.as__home__singleImage-animate', { 
        scrollTrigger: {
            trigger: '.as__home__singleImage-animate'
        },
        width: 0, 
        duration: 2, 
        ease: "expo.inOut",
    })

    new SplitTextV2('.as__home__video-text')
    new SplitTextV2('.poster__info .as__title_h2')
    new SplitTextV2('.poster__info .parag')
    new SplitTextV2('.as__home__shop .as__title_h2')
    new SplitTextV2('.as__home__shop .as__title_h5')
    new SplitTextV2('.as__home__shop .parag')
    new SplitTextV2('.shop .parag')
    new SplitTextV2('.shop .as__title_h4')
    new SplitTextV2('.carouselBeers__single--title')
    new SplitTextV2('.carouselBeers__single--desc')
    new SplitTextV2('.as__home__weAre__left__description .parag')

	gsap.from('.as__home__banner .flash2', {
        scrollTrigger: {
            trigger: '.as__home__banner .flash2',
            scrub: 3,
        },
        yPercent: 100,
        ease: 'none'
    })

	gsap.from('.as__home__video .flash1', {
        scrollTrigger: {
            trigger: '.as__home__video .flash1',
            scrub: 3,
        },
        yPercent: 100,
        ease: 'none'
    })

	gsap.from('.as__home__video .flash2', {
        scrollTrigger: {
            trigger: '.as__home__video .flash2',
            scrub: 3,
        },
        yPercent: 100,
        ease: 'none'
    })

	gsap.from('.as__home__video .wave', {
        scrollTrigger: {
            trigger: '.as__home__video .wave',
            scrub: 3,
        },
        yPercent: 100,
        ease: 'none'
    })

	gsap.from('.as__home__shop .wave', {
        scrollTrigger: {
            trigger: '.as__home__shop .wave',
            scrub: 4,
        },
        yPercent: 100,
        ease: 'none'
    })

	gsap.from('.as__home__shop .sig', {
        scrollTrigger: {
            trigger: '.as__home__shop .sig',
            scrub: 4,
        },
        yPercent: 100,
        ease: 'none'
    })

	gsap.from('.as__home__beers .sig2', {
        scrollTrigger: {
            trigger: '.as__home__beers .sig2',
            scrub: 4,
        },
        yPercent: 100,
        ease: 'none'
    })

	gsap.from('.as__home__beers .sig3', {
        scrollTrigger: {
            trigger: '.as__home__beers .sig3',
            scrub: 4,
        },
        yPercent: 100,
        ease: 'none'
    })

	gsap.from('.as__home__beers .line', {
        scrollTrigger: {
            trigger: '.as__home__beers .line',
            scrub: 4,
        },
        yPercent: 100,
        ease: 'none'
    })

	gsap.from('.as__home__beers .line2', {
        scrollTrigger: {
            trigger: '.as__home__beers .line2',
            scrub: 4,
        },
        yPercent: 100,
        ease: 'none'
    })

	gsap.from('.as__home__weAre__figure--small', {
        scrollTrigger: {
            trigger: '.as__home__weAre__figure--small',
            scrub: 3,
        },
        yPercent: 100,
        ease: 'none'
    })

	gsap.from('.as__home__weAre__figure--right', {
        scrollTrigger: {
            trigger: '.as__home__weAre__figure--right',
            scrub: 3,
        },
        yPercent: 100,
        ease: 'none'
    })

	gsap.from('.as__home__weAre__left__action-parallax', {
        scrollTrigger: {
            trigger: '.as__home__weAre__left__action-parallax',
            scrub: 4,
        },
        yPercent: 100,
        ease: 'none'
    })

	gsap.from('.as__home__weAre__star', {
        scrollTrigger: {
            trigger: '.as__home__weAre__star',
            scrub: 4,
        },
        yPercent: 50,
        ease: 'none'
    })
}

const downloadStickers = () => {
	const button = document.querySelector('.as__home__stickers__action a') as HTMLElement

	if (window.innerWidth >= 767) {
		const stickers = document.querySelectorAll('.as__home__stickers__box')
		
		stickers.forEach((stic, index) => {
			const image = stic.querySelector('img')
			if (index == 0) {
				stic.classList.add('sticker__download')
				button.setAttribute('href', `${image.getAttribute('src')}`)
			}

			stic.addEventListener('click', () => {
				stickers.forEach(s =>  s.classList.remove('sticker__download') );
				stic.classList.add('sticker__download')
				button.setAttribute('href', `${image.getAttribute('src')}`)
			})
		});

        button.addEventListener('click', () => {
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'Button',
                'event_label': `${button.getAttribute('href')}_Home`,
                'interaction':'true',
                'component_name': 'Home_Section_Aguila_Stickers',
                'element_text': `${button.innerText}`,
            });
		})
	}

	else {
        button.addEventListener('click', () => {
            const stickerActive = document.querySelector('.as__home__stickers__box.swiper-slide-active')
            const image = stickerActive.querySelector('img')
			button.setAttribute('href', `${image.getAttribute('src')}`)

            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'Button',
                'event_label': `${button.getAttribute('href')}_Home`,
                'interaction':'true',
                'component_name': 'Home_Section_Aguila_Stickers',
                'element_text': `${button.innerText}`,
            });
		})
	}
}

function getVideoId(videoUrl: string) {
    if (videoUrl) {
        const match = videoUrl.match(
            /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
        );
        return match && match[7].length == 11 ? match[7] : false;
    }
}

const posterVideo = () => {
	const openModal = document.querySelector('.poster__image') as HTMLElement
	const url = openModal.getAttribute('data-url') as string
    const videoId = getVideoId(url)
	const modal = document.querySelector('.as__modal')
	const closeModal = document.querySelector('.as__modal__close')
    
    openModal?.addEventListener("click", () => {
        modal?.classList.remove('as__close');
        
        window.player = YouTubePlayer("play", {
            //@ts-ignore
            videoId: videoId,
        });
        
        window.player.playVideo();

        window.player.on('stateChange', (event: any) => {
            if (event.target.getPlayerState() == 1) {
                window.dataLayer.push({
                    'event': 'GAEvent',
                    'event_category': 'Video',
                    'event_action': 'Play',
                    'event_label': `${event.target.videoTitle}`,
                    'interaction':'true'
                })
            }

            else if (event.target.getPlayerState() == 0) {
                window.dataLayer.push({
                    'event': 'GAEvent',
                    'event_category': 'Video',
                    'event_action': 'Completed',
                    'event_label': `${event.target.videoTitle}`,
                    'interaction':'true'
                })
            }
        });
    });

	closeModal?.addEventListener('click', () => {
        window.player.pauseVideo();

		window.player.on('stateChange', (event: any) => {
            console.log('state close')
            console.log(event.target.getPlayerState())
            if (event.target.getPlayerState() == 2) {
                console.log('state 2')
                window.dataLayer.push({
                    'event': 'GAEvent',
                    'event_category': 'Video',
                    'event_action': 'Close Video',
                    'event_label': `${event.target.videoTitle}`,
                    'interaction':'true'
                })
            }
        });

        modal.classList.add('as__close')

        setTimeout(() => {
            window.player.destroy();
        }, 1000);
	})
}

const setActiveBeers = () => {
	const slides = document.querySelectorAll('.carouselBeers__single.swiper-slide')

	slides.forEach((slide, index) => {
		if (index == 0) {
			slide.classList.add('single__active')
		}

		slide.addEventListener('mouseover', () => {
            let title = slide.querySelector('.carouselBeers__single--title') as HTMLElement
			slides.forEach(e => e.classList.remove('single__active'))
			slide.classList.add('single__active')
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Content',
                'event_action': 'Card',
                'event_label': `${title.innerText}_Product-Home`,
                'interaction':'true',
                'component_name': 'Home_Section_Cervezas',
                'element_text': `${title.innerText}`,
            });
		})
	});
}

function swiper() {
	const swiper = new Swiper('.swiperBanner', {
		modules: [Pagination, Navigation],
		slidesPerView: 1,
		spaceBetween: 45,
        observer: true,
		pagination: {
			el: ".swiper-pagination",
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

	const swiperShop = new Swiper('.swiperShop', {
		modules: [Pagination],
		slidesPerView: 1,
		spaceBetween: 20,
		pagination: {
			el: ".swiper-pagination",
		},
        breakpoints: {
            991: {
                slidesPerView: 3,
                spaceBetween: 25,
            }
        }
	});

	const swiperBeers = new Swiper('.carouselBeers', {
		modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 20,
		pagination: {
			el: ".swiper-pagination",
		},
        breakpoints: {
            991: {
                slidesPerView: 3,
                spaceBetween: 30
            }
        }
    });

	const swiperStickers = new Swiper('.as__home__stickers__car', {
        modules: [Pagination],
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination",
        },
        breakpoints: {
            // when window width is >= 320px
            767: {
                slidesPerView: 3,
                spaceBetween: 24
            },
        }
    });
	const carouselInteractions = new Swiper('.carouselInteractions', {
        modules: [Pagination],
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination",
        },
        breakpoints: {
            // when window width is >= 320px
            767: {
                slidesPerView: 2,
                spaceBetween: 11
            },
        }
    });
}